import { SxProps } from '@mui/material';
import theme from 'providers/theme/theme';

export const notesContainerStyles: SxProps = {
  overflowY: 'scroll',
  overflowX: 'hidden',
  '&::-webkit-scrollbar': { width: 4, height: 116, WebkitAppearance: 'none' },
  '&::-webkit-scrollbar-thumb': {
    borderRadius: 50,
    border: '2px solid',
    borderColor: '#ECECEC',
    backgroundColor: 'rgba(0 0 0 / 0.5)',
  },
};

const { greyGradientFrom, greyGradientTo, limeGradientFrom, limeGradientTo } = theme.palette.custom;

export const greyGradientSx: SxProps = {
  background: `linear-gradient(to bottom, ${greyGradientFrom}, ${greyGradientTo})`,
};

export const limeGradientSx: SxProps = {
  background: `linear-gradient(to bottom, ${limeGradientFrom}, ${limeGradientTo})`,
};

export const saveButtonStyles: SxProps = {
  fontSize: 14,
  fontWeight: 500,
  minWidth: 117,
  height: 32,
  px: 3,
  py: 2.25,
  color: '#fff',
  bgcolor: '#191919',
  borderRadius: 16,
  textTransform: 'none',
  boxShadow: 'none',
  transition: 'opacity 0.2s ease',
  '&:hover, &:focus-visible': {
    opacity: 0.8,
  },
  '&:disabled': {
    bgcolor: '#191919',
    opacity: 0.8,
    color: '#fff',
  },
};

export const cancelButtonStyles: SxProps = {
  fontSize: 14,
  fontWeight: 500,
  minWidth: 116,
  height: 32,
  px: 3,
  py: 2.25,
  bgcolor: 'common.white',
  color: '#181819',
  borderRadius: 16,
  textTransform: 'none',
  boxShadow: 'none',
  transition: 'opacity 0.2s ease',
  '&:hover, &:focus-visible': {
    boxShadow: 'none',
    opacity: 0.8,
  },
};

export const getAddNoteIconSx = (isMaxNotes: boolean): SxProps => ({
  width: 24,
  height: 24,
  borderRadius: '50%',
  bgcolor: isMaxNotes ? 'grey.400' : 'common.black',
  color: 'common.white',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 18,
  fontWeight: 300,
});

export const inputContainerSx: SxProps = {
  mb: 4,
  bgcolor: 'common.white',
  borderRadius: 3,
  px: 3,
  py: 2,
  position: 'relative',
  height: 228,
};

export const getFloatingLabelSx = (isSmall: boolean): SxProps => ({
  position: 'absolute',
  top: isSmall ? 8 : 24,
  left: 12,
  fontSize: isSmall ? 12 : 14,
  lineHeight: isSmall ? 1 : 1.4,
  letterSpacing: isSmall ? 0 : '-0.14px',
  color: '#787878',
  transition: 'all 0.15s ease',
  pointerEvents: 'none',
  zIndex: 1,
});

export const noteTextFieldSx: SxProps = {
  height: '100%',
  '& .MuiOutlinedInput-root': {
    border: 'none',
    p: 0,
    pt: 4,
    height: '100%',
    alignItems: 'flex-start',
    '& fieldset': { border: 'none' },
    '& textarea': { height: '100% !important', overflow: 'auto !important' },
  },
};

export const deleteButtonSx: SxProps = {
  p: 1,
  transition: 'background-color 0.2s ease',
  '&:hover': { bgcolor: 'rgba(0, 0, 0, 0.08)' },
  '&.Mui-disabled': { opacity: 0.8 },
};

export const notesExpandedHeadingSx: SxProps = {
  fontWeight: 500,
  fontSize: 15,
  lineHeight: '22px',
  mb: 4,
};
